import React from 'react';
import { useParams } from 'react-router-dom';
import { useEvent } from '../../../../data/hooks/eventHooks';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import { useMeeting } from '../../../../data/hooks/meeting/useMeeting';
import { useMeetingInvites } from '../../../../data/hooks/meeting/useMeetingInvites/useMeetingInvites';
import TopBarEvent from '../../../elements/TopBar/TopBarEvent';
import Screen from '../../Screen';
import MeetingContextTitle from './MeetingContextTitle';
import MeetingInvite from './MeetingInvite';
import MeetingPeer from './MeetingPeer';
import MeetingState from './MeetingState';
import MeetingTimeAndLocation from './MeetingTimeAndLocation';
import OthersInvited from './OthersInvited';
import RejectionReason from './RejectionReason';
import ProgramAtTime from './ProgramAtTime';
import { isMeetingConfirmed } from 'common-data-handling';
import { useMeetingNotifications } from '../../../../data/hooks/notifications/useMeetingNotifications';
import { useMarkNotificationsRead } from '../../../../data/hooks/notifications/useMarkNotificationsRead';
import MeetingStateController from '../../../elements/MeetingStateController';
import styles from './MeetingDetailsScreen.module.scss';
import VirtualRoomMeetingButton from './VirtualRoomMeetingButton';

function MeetingDetailsScreen(props) {
    const { eventId, meetingId } = props,
        event = useEvent(eventId),
        meeting = useMeeting(eventId, meetingId),
        invites = useMeetingInvites(eventId, meetingId, { includeInitiator: true }),
        i18n = useI18n(),
        confirmed = isMeetingConfirmed(meeting),
        unreadNotifications = useMeetingNotifications(eventId, meetingId, {
            filter: (n) => !n.read,
        });

    useMarkNotificationsRead(unreadNotifications);

    // console.log('DBG meeting', meeting, invites);

    const header = (
            <>
                <TopBarEvent event={event}>{i18n['label.meeting-request']}</TopBarEvent>
            </>
        ),
        footer = confirmed ? (
            <MeetingStateController className={styles.footerController} rescheduleClassName={styles.reschedule} rejectClassName={styles.reject} event={event} meeting={meeting} />
        ) : null;

    return (
        <Screen className={'bg-shade-2'} header={header} footer={footer}>
            <div className="content bg-shade-2">
                <MeetingContextTitle meeting={meeting} />
                <MeetingPeer user={invites[0].user} />
                <MeetingInvite meeting={meeting} />
                <RejectionReason className="marginTop" invite={invites[0]} meeting={meeting} />
                <OthersInvited meeting={meeting} exclude={[invites[0].user.id]} />
            </div>
            <div className="bg-shade-2">
                <MeetingState meeting={meeting} />
            </div>
            <MeetingTimeAndLocation className="bg-white" event={event} meeting={meeting} />
            <ProgramAtTime className="bg-shade-1" eventId={eventId} start={meeting.start_local} end={meeting.end_local} title={confirmed ? i18n['label.program'] : i18n['label.schedule.at-time']} />
            {!confirmed ? <MeetingStateController event={event} meeting={meeting} /> : null}
            <div className="content marginTop marginBottom">
                <VirtualRoomMeetingButton event={event} meeting={meeting} />
            </div>
        </Screen>
    );
}

export default () => {
    const { eventId, meetingId } = useParams();
    return <MeetingDetailsScreen eventId={eventId} meetingId={meetingId} />;
};
